import {NgModule} from '@angular/core';
import {TechnicalDevicePreviewComponent} from './technical-device-preview/technical-device-preview.component';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@helpers/modules/shared.module';
import {Lab365CommonModule} from '@lab365/common';

@NgModule({
    declarations: [
        TechnicalDevicePreviewComponent,
    ],
    exports: [
        TechnicalDevicePreviewComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        Lab365CommonModule,
    ]
})
export class ObjectsCommonComponentsModule {
}
